/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComputeSpeciesResponse
 */
export interface ComputeSpeciesResponse {
    /**
     * 
     */
    triggeredCaptureIds: Array<string>;
    /**
     * 
     */
    flowRunIds: Array<string>;
}

/**
 * Check if a given object implements the ComputeSpeciesResponse interface.
 */
export function instanceOfComputeSpeciesResponse(value: object): value is ComputeSpeciesResponse {
    if ((!('triggeredCaptureIds' in (value as Record<string, any>)) && !('triggered_capture_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['triggeredCaptureIds'] === undefined && (value as Record<string, any>)['triggered_capture_ids'] === undefined)) return false;
    if ((!('flowRunIds' in (value as Record<string, any>)) && !('flow_run_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['flowRunIds'] === undefined && (value as Record<string, any>)['flow_run_ids'] === undefined)) return false;
    return true;
}

export function ComputeSpeciesResponseFromJSON(json: any): ComputeSpeciesResponse {
    return ComputeSpeciesResponseFromJSONTyped(json, false);
}

export function ComputeSpeciesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputeSpeciesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'triggeredCaptureIds': json['triggered_capture_ids'],
        'flowRunIds': json['flow_run_ids'],
    };
}

export function ComputeSpeciesResponseToJSON(json: any): ComputeSpeciesResponse {
    return ComputeSpeciesResponseToJSONTyped(json, false);
}

export function ComputeSpeciesResponseToJSONTyped(value?: ComputeSpeciesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'triggered_capture_ids': value['triggeredCaptureIds'],
        'flow_run_ids': value['flowRunIds'],
    };
}

